__turbopack_context__.v({
  "className": "robotomono_fd10efd0-module__YnciIG__className",
  "variable": "robotomono_fd10efd0-module__YnciIG__variable",
});
